/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class UtilitiesPanelService {
    private navigateData: any = {
        'distributors': {},
        'genealogies': {},
        'reports': {},
        'shareWithMe': {}
    };

    private endPointUrls: any = {
        "RVC": environment.host + '/home/lastAccessReport/',
        "BSC": environment.host + '/home/bookmark/'
    };

    constructor(private http: HttpClient) {
    }

    public getNavigateData() {
        return this.navigateData;
    }

    public setNavigateData(navData: any) {
        this.navigateData = navData;
    }

    public resetNavigateData() {
        this.navigateData = {
            'distributors': {},
            'genealogies': {},
            'reports': {},
            'shareWithMe': {}
        }
    }

    public createUtilityItem(cardCode: any, requestPayLoad: any) {
		return this.http.post(this.endPointUrls[cardCode], requestPayLoad).toPromise();
    }
    
    public updateUtilityItem(cardCode: any, itemId: any, requestPayLoad: any) {
		const updateUrl = this.endPointUrls[cardCode] + itemId;
		return this.http.put(updateUrl, requestPayLoad).toPromise();
	}

    public deleteUtilityItem(cardCode: any, itemId: any) {
		const deleteUrl = this.endPointUrls[cardCode] + itemId;
		return this.http.delete(deleteUrl).toPromise();
    }

    public shareUtility(cardCode: any, requestPayLoad: any) {
		return this.http.post(this.endPointUrls[cardCode]+'share', requestPayLoad).toPromise();
    }
}